export enum BillingPlanTier {
  Legacy = 'legacy',
  Launch = 'launch',
  Scale = 'scale',
  Lead = 'lead',
}

export type BillingPlan = {
  id: number;
  basePrice?: number;
  baseSlots: number;
  billingPeriod: 1 | 12;
  tier: BillingPlanTier;
  currency: 'EUR' | 'USD' | 'GBP';
  pricing: Record<1 | 12, { slotPrice: number; basePrice: number }>;
  createdAt: number;
  custom: boolean;
};

export type PricingProduct = {
  id: number;
  custom: boolean;
  baseSlots: number;
  codename: BillingPlanTier;
  createdAtTimestamp: number;
  currency: 'EUR' | 'USD' | 'GBP';
  monthlyBaseAmount: number;
  monthlySlotAmount: number;
  yearlyBaseAmount: number;
  yearlySlotAmount: number;
  legacy: boolean;
};
